import React, { useContext } from "react";
import Routepath from "./Routes/routepath";
import { Route, Routes } from "react-router-dom";
import FormContext from "./context/FormContext";
import Footer from "./Components/footer/Footer";

function App() {
  const context = useContext(FormContext);
  const { Loading } = context;

  if (Loading) {
    return (
      <div
        style={{
          height: "100vh",
          width: "100%",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <div
          className="spinner-border"
          style={{ color: "#88b0bc" }}
          role="status"
        >
          <span className="sr-only">Loading...</span>
        </div>
      </div>
    );
  }

  return (
    <React.Fragment>
      <Routes>
        {Routepath.map((item, i) => {
          return <Route key={i} path={item.path} element={item.element} />;
        })}
      </Routes>
      <Footer />
    </React.Fragment>
  );
}

export default App;
